import React, { useContext, useEffect, useState } from "react";
import PERFORMANCE from "../../../../Assets/Images/PERFORMANCE.png";
import STRATEGIC from "../../../../Assets/Images/STRATEGIC.png";
import VISIONARY from "../../../../Assets/Images/VISIONARY.png";
import COLLABORATIVE from "../../../../Assets/Images/COLLABORATIVE.png";
import HeaderPreview from "../../../GeneratePdf/HeaderPreview";
import FooterPreview from "../../../GeneratePdf/FooterPreview";
import GroupReportContext from "../../../../Context/GroupReportContext";
import { useGroupReportDate } from '../../../../Context/GroupReportDate';
import { initialDataLeaderShip } from "../groupReport-pdf/QuadrantInFocus";
import { logItemsOverviewData } from '../../../../utils/itemsOverviewLogger';

export const leadershipData = [
  {
    no: 33, score: 1,
    quadrant: "PERFORMANCE",
    question: "[First Name] takes pride in superior execution.",
    s: 3, m1: 3, d1: 3, p1: 3, p2: 3, o1: 3, a: 3,
  },
  {
    no: 34, score: 4,
    quadrant: "COLLABORATIVE",
    question: "[First Name] enjoys building an empowering culture at work.",
    s: 3, m1: 3, d1: 3, p1: 3, p2: 3, o1: 3, a: 3,
  },
  {
    no: 35, score: 3,
    quadrant: "VISIONARY",
    question: "[First Name] can weave a powerful narrative that unites people for a common purpose.",
    s: 3, m1: 3, d1: 3, p1: 3, p2: 3, o1: 3, a: 3,
  },
  {
    no: 36, score: 2,
    quadrant: "STRATEGIC",
    question: "[First Name] believes success is contingent on thinking smarter.",
    s: 3, m1: 3, d1: 3, p1: 3, p2: 3, o1: 3, a: 3,
  },
  {
    no: 37, score: 2,
    quadrant: "STRATEGIC",
    question: "[First Name] finds great satisfaction in developing effective strategies for the organization.",
    s: 3, m1: 3, d1: 3, p1: 3, p2: 3, o1: 3, a: 3,
  },
  {
    no: 38, score: 4,
    quadrant: "COLLABORATIVE",
    question: "[First Name] wants the team to be fully engaged in the decision-making process.",
    s: 3, m1: 3, d1: 3, p1: 3, p2: 3, o1: 3, a: 3,
  },
  {
    no: 39, score: 1,
    quadrant: "PERFORMANCE",
    question: "[First Name] likes to win in a competitive environment.",
    s: 3, m1: 3, d1: 3, p1: 3, p2: 3, o1: 3, a: 3,
  },
  {
    no: 40, score: 3,
    quadrant: "VISIONARY",
    question: "[First Name] can usually see what lies ahead in the future of the organization.",
    s: 3, m1: 3, d1: 3, p1: 3, p2: 3, o1: 3, a: 3,
  },
];

const sideLabels = [
  { label: "INFLUENCE", bg: "#394554" },
  { label: "DIRECTION", bg: "#666666" },
];

const Logo = (quadrant) => {
  switch (quadrant) {
    case 'PERFORMANCE':
      return <img style={{ width: "14px" }} src={PERFORMANCE} alt="PERFORMANCE" className="logo" />;
    case 'STRATEGIC':
      return <img style={{ width: "14px" }} src={STRATEGIC} alt="STRATEGIC" className="logo" />;
    case 'VISIONARY':
      return <img style={{ width: "14px" }} src={VISIONARY} alt="VISIONARY" className="logo" />;
    case 'COLLABORATIVE':
      return <img style={{ width: "14px" }} src={COLLABORATIVE} alt="COLLABORATIVE" className="logo" />;
    default:
      return null;
  }
};

const LeadershipFourthItemOverview360 = ({ apiData, reportType, pageNumber }) => {
  const [dynamicData] = useState([...initialDataLeaderShip]);
  const groupReportCtx = useContext(GroupReportContext);
  const { updateTablevaluels2Page4 } = useGroupReportDate();
  const respondentName = apiData?.fullName?.split(' ')[0] || '[First Name]';

  const allMembersDataArray = Object.values(apiData?.memberResults?.allMembersData || {});
  const allVariableSets = allMembersDataArray.map(el => el.variables);
  const allAssessmentDesignation = allMembersDataArray.map(el => el?.designation);
  const allAssessmentHash = allMembersDataArray.map(el => el.hash);
  const allAssessmentFullName = allMembersDataArray.map(el => el.fullName);

  const quadrantScores = {
    "PERFORMANCE": 1,
    "STRATEGIC": 2,
    "VISIONARY": 3,
    "COLLABORATIVE": 4
  };

  const allResults = [];
  dynamicData?.forEach((el) => {
    const res = groupReportCtx?.calculateQuestionScoreLeadership(
      quadrantScores?.[el.quadrant],
      allVariableSets,
      el.no,
      "360_overview",
      allAssessmentDesignation,
      allAssessmentHash,
      allAssessmentFullName
    );
    if (res?.averageScore !== null) {
      allResults.push(res);
    }
  });

  // Collect all scores and save to context (page4)
  useEffect(() => {
    if (!allResults.length) return;

    const scoresArray = [];
    dynamicData.slice(32, 44).forEach((_, index) => {
      const selfScore = groupReportCtx?.getAverageScore("360 Assessment", allResults, index + 32);
      const managerScore = groupReportCtx?.getAverageScore("360 Assessment Manager", allResults, index + 32);
      const directReportScore = groupReportCtx?.getAverageScore("360 Assessment Direct Report", allResults, index + 32);
      const peerScore = groupReportCtx?.getAverageScore("360 Assessment Peer", allResults, index + 32);
      const otherScore = groupReportCtx?.getAverageScore("360 Assessment Other", allResults, index + 32);
      const averageScore = groupReportCtx?.getObserverAverageScore(allResults, index + 32) ?? "-";
      scoresArray.push([selfScore, managerScore, directReportScore, peerScore, otherScore, averageScore]);
    });

    updateTablevaluels2Page4(scoresArray);
    logItemsOverviewData({
      pageName: "Leadership Flow 4",
      items: dynamicData.slice(32, 44),
      allResults,
      getAverageScore: groupReportCtx.getAverageScore,
      startIndex: 32,
    });
  }, [allResults, dynamicData, groupReportCtx, updateTablevaluels2Page4]);

  const getLabelByIndex = (idx) => {
    if (idx === 0) return sideLabels[0].label;
    return sideLabels[Math.floor(idx / 4)]?.label;
  };

  const getStyleByIndex = (idx) => {
    if (idx === 0) return { top: "12px", height: "50%", backgroundColor: sideLabels[0].bg };
    return { top: "52.98%", height: "50%", backgroundColor: sideLabels[Math.floor(idx / 4)]?.bg };
  };

  return (
    <div style={{ backgroundColor: "rgb(255, 255, 255)" }}>
      <HeaderPreview />
      <div className="page" style={{ paddingBottom: "0", height: "634px", boxSizing: "border-box", position: "relative" }}>
        <div className="content">
          <div className="table" style={{ position: "relative" }}>
            <div className="tableRow tableHeader" style={{ background: "#245775", color: "#fff", display: "flex", zIndex: "1", position: "relative" }}>
              <div className="cellIndex" style={{ marginLeft: "40px", display: "flex", alignItems: "center" }}>#</div>
              <div className="cellQuadrant" style={{ fontSize: "9px", width: "15%", padding: "5.5px 0px 5.5px 13px", lineHeight: "13px" }}>Quadrant</div>
              <div className="cellLogo" style={{ width: "9%" }}></div>
              <div className="cellQuestion" style={{marginRight: "14px" }}>Question</div>
              <div className="cellscore-parent" style={{ display: "flex", marginLeft: "16px" }}>
                <div className="cellScore">S</div>
                <div className="cellScore">M</div>
                <div className="cellScore">D</div>
                <div className="cellScore">P</div>
                <div className="cellScore">O</div>
                <div className="cellScore">A</div>
              </div>
            </div>

            {dynamicData?.slice(32, 44).map((item, index) => {
              const selfScore = Number(groupReportCtx?.getAverageScore("360 Assessment", allResults, index + 32));
              const managerScore = Number(groupReportCtx?.getAverageScore("360 Assessment Manager", allResults, index + 32));
              const directReportScore = Number(groupReportCtx?.getAverageScore("360 Assessment Direct Report", allResults, index + 32));
              const peerScore = Number(groupReportCtx?.getAverageScore("360 Assessment Peer", allResults, index + 32));
              const otherScore = Number(groupReportCtx?.getAverageScore("360 Assessment Other", allResults, index + 32));
              const averageScore = Number(groupReportCtx?.getObserverAverageScore(allResults, index + 32));

              return (
                <div key={index} style={{ display: "flex", alignItems: "center", padding: "5px 0", }} className={`tableRow ${index % 2 === 0 ? 'evenRow' : 'oddRow'}`}>
                  <div className='cellIndex'></div>
                  {index === 0 || index % 4 === 0 ? (
                    <div className="sidelables" style={getStyleByIndex(index)}>
                      {getLabelByIndex(index)}
                    </div>
                  ) : null}
                  <div className="cellIndex" style={{ marginLeft: "30px" }}>{index + 33}.</div>
                  <div className="cellQuadrant" style={{ width: "75px", fontSize: "9px", padding: "5.5px 5px 5.5px 13px", lineHeight: "13px" }}>{item.quadrant}</div>
                  <div className="cellLogo">{Logo(item.quadrant)}</div>
                  <div className="cellQuestion">{leadershipData[index]?.question.replace(/\[First Name\]/g, respondentName)}</div>
                  <div className="cellScore-parent" style={{ display: "flex", alignItems: "center", marginLeft: "" }}>
                    <div className="cellScore">{Number.isNaN(selfScore) ? "-" : selfScore.toFixed(1)}</div>
                    <div className="cellScore">{Number.isNaN(managerScore) ? "-" : managerScore.toFixed(1)}</div>
                    <div className="cellScore">{Number.isNaN(directReportScore) ? "-" : directReportScore.toFixed(1)}</div>
                    <div className="cellScore">{Number.isNaN(peerScore) ? "-" : peerScore.toFixed(1)}</div>
                    <div className="cellScore">{Number.isNaN(otherScore) ? "-" : otherScore.toFixed(1)}</div>
                    <div className="cellScore">{averageScore === 0 || Number.isNaN(averageScore) ? "-" : averageScore.toFixed(1)}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className='details-footer' style={{ position: "absolute", bottom: "4px", width: "100%", boxSizing: "border-box", margin: "0" }}>
          <ul className='details-list'>
            <li>S - Self</li>
            <li>M - Manager</li>
            <li>D - Direct Report</li>
            <li>P - Peer</li>
            <li>O - Other</li>
            <li>A - Average</li>
          </ul>
        </div>
      </div>
      <FooterPreview pageNumber={pageNumber} reportType={reportType} />
    </div>
  );
};

export default LeadershipFourthItemOverview360;
